/*
 * @Description: 线索有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  是: '是',
  否: '否',
  将: '将',
  给: '给',
  原因是: '原因是',
  转化: '转化',
  查看: '查看',
  线索: '线索',
  商机: '商机',
  客户: '客户',
  产品: '产品',
  日程: '日程',
  提醒: '提醒',
  重点: '重点',
  详情: '详情',
  报价单: '报价单',
  参会人: '参会人',
  已转化: '已转化',
  请填写: '请填写',
  加载中: '加载中',
  联系人: '联系人',
  下一步: '下一步',
  上一步: '上一步',
  销售合同: '销售合同',
  销售订单: '销售订单',
  售后服务: '售后服务',
  销售线索: '销售线索',
  新增线索: '新增线索',
  编辑线索: '编辑线索',
  新建日程: '新建日程',
  编辑日程: '编辑日程',
  跟进时间: '跟进时间',
  跟进方式: '跟进方式',
  日程主题: '日程主题',
  转移线索: '转移线索',
  导入: '导入',
  点击拨打: '点击拨打',
  温馨提醒: '温馨提醒',
  建议无效: '建议无效',
  客户档案: '客户档案',
  转化信息: '转化信息',
  客户名称: '客户名称',
  商机名称: '商机名称',
  商机信息: '商机信息',
  系统信息: '系统信息',
  基本信息: '基本信息',
  通话记录: '通话记录',
  工商信息: '工商信息',
  分配记录: '分配记录',
  转移: '转移',
  转移给: '转移给',
  转移的原因是: '转移的原因是',
  领取: '领取',
  分配给: '分配给',
  自动分配给: '自动分配给',
  退回到: '退回到',
  退回原因是: '退回原因是',
  自动退回到: '自动退回到',
  转移线索池: '转移线索池',
  退回: '退回',
  批量转移: '批量转移',
  是必填项: '是必填项',
  是必选项: '是必选项',
  模板下载: '模板下载',
  导入出错: '导入出错',
  上传失败: '上传失败',
  客户信息: '客户信息',
  暂无数据: '暂无数据',
  正在上传中: '正在上传中',
  数据导出中: '数据导出中',
  转化为客户: '转化为客户',
  转化为: '转化为',
  当前负责人: '当前负责人',
  未找到联系人: '未找到联系人',
  呼叫已拨出: '呼叫已拨出',
  出错了: '出错了',
  最后更新时间: '最后更新时间',
  批量转移线索: '批量转移线索',
  模板下载出错: '模板下载出错',
  查看工商信息: '查看工商信息',
  关联工商信息: '关联工商信息',
  数据获取失败: '数据获取失败',
  更新中: '线索更新中，请等待',
  暂无分配记录: '暂无分配记录',
  输入日程主题: '输入日程主题',
  请选择公司名称: '请选择公司名称',
  请输入公司名称: '请输入公司名称',
  请输入客户名称: '请输入客户名称',
  LP池: 'LP池',
  LP跟进信息: 'LP跟进信息',
  LP出资信息: 'LP出资信息',
  实缴信息: '实缴信息',
  基金: '基金',
  请输入LP主体名称: '请输入LP主体名称',
  请输入LP主体名称或拟投基金名称: '请输入LP主体名称或拟投基金名称',
  请输入基金名称: '请输入基金名称',

  请选择已关联客户名称: '请选择已关联客户名称',
  只能选择一个负责人: '只能选择一个负责人',
  日程主题是必填项: '日程主题是必填项',
  跟进方式是必选项: '跟进方式是必选项',
  请选择跟进方式: '请选择跟进方式',
  Apaas线索导入: 'Apaas线索导入',
  跟进时间为必填项: '跟进时间为必填项',
  销售线索是必填项: '销售线索是必填项',
  获取当前进度失败: '获取当前进度失败',
  公司名称是必填项: '公司名称是必填项',
  无效原因是必填项: '无效原因是必填项',
  跟进人不可编辑: '跟进人不可编辑',
  上传文件格式不正确: '上传文件格式不正确',
  暂无此线索查看: '暂无此线索查看权限',
  请先保存线索基本信息: '请先保存线索基本信息',
  线索转化数据获取失败: '线索转化数据获取失败',
  线索详情数据获取失败: '线索详情数据获取失败',
  动态记录数据获取失败: '动态记录数据获取失败',
  线索详情EXCEL模板: '线索详情EXCEL模板',
  点击将重新获取Apaas线索数据: '点击将重新获取Apaas线索数据',
  不支持转移的线索名称如下: '不支持转移的线索名称如下',
  点击或拖拽文件到此处上传: '点击或拖拽文件到此处上传',
  apass导入的线索不能转化为商机: 'apass导入的线索不能转化为商机',
  // ----------------------------------------------------------------
  新增线索数: '新增线索数',
  待我跟进的: '待我跟进的',
  清空筛选条件: '清空筛选条件',
  搜索选项外置: '搜索选项外置',
  暂无外呼拨打号码: '暂无外呼拨打号码',
  以上指标将横向固定: '以上指标将横向固定',
  请搜索客户名称并选择: '请搜索客户名称并选择',
  主叫外显号码: '主叫外显号码',
  被叫外显号码: '被叫外显号码',
  您收到的来电号码: '您收到的来电号码',
  客户收到的来电号码: '客户收到的来电号码',
  只能选择一个用户: '只能选择一个用户',
  手机号不能为空: '手机号不能为空',
  姓名不能为空: '姓名不能为空',
  搜索流程名称: '搜索流程名称',
  请输入流程名称: '请输入流程名称',
  请选择启用状态: '请选择启用状态',
  请选择触发动作: '请选择触发动作',
  请选择流程发起对象: '请选择流程发起对象',
  请选择对象字段: '请选择对象字段',
  商机状态有没选择的: '商机状态有没选择的',
  赢率是必填项: '赢率是必填项',
  '请选择省份/城市': '请选择省份/城市',
  '文件已存在，请修改': '文件已存在，请修改',
  '请输入字段标识,可用于api对接': '请输入字段标识,可用于api对接',
  '字段标识不能为空,请重新设置': '字段标识不能为空,请重新设置',
  '停用后该规则将不再可用，是否确认？': '停用后该规则将不再可用，是否确认？',
  '提示信息不能为空,请重新设置': '提示信息不能为空,请重新设置',
  '请注意，只可选择一个人员或部门哦': '请注意，只可选择一个人员或部门哦',
  '适用范围不能为空，请重新设置': '适用范围不能为空，请重新设置',
  '字段名称不能为空,请重新设置': '字段名称不能为空,请重新设置',
  '暂未配置表头，请先配置': '暂未配置表头，请先配置',
  新分配线索: '新分配线索',
  '您非线索池管理员，不可分配线索': '您非线索池管理员，不可分配线索',
  分配: '分配',
  领取成功: '领取成功',
  录音文件: '录音文件',
  导入新数据: '导入新数据',
  准备新数据文件: '准备新数据文件',
  下载数据模板: '下载数据模板',
  注意事项: '注意事项',
  '若设置后台开启查重后，重复数据将不会新增': '若设置后台开启查重后，重复数据将不会新增',
  '模板中的表头字段名称不可更改，表头行不能删除': '模板中的表头字段名称不可更改，表头行不能删除',
  必填项必须保留: '必填项必须保留',
  只能上传excel格式文件: '只能上传excel格式文件',
  上传文件: '上传文件',
  更新现有数据: '更新现有数据',
  准备更新数据文件: '准备更新数据文件',
  '可从列表页导出含有【唯一ID】字段的数据，【唯一ID】字段将作为匹配原数据的唯一标识，请勿随意修改或删除': '可从列表页导出含有【唯一ID】字段的数据，【唯一ID】字段将作为匹配原数据的唯一标识，请勿随意修改或删除',
  '文件中必须有【唯一ID】字段，名称不一致或不存在时会导入失败': '文件中必须有【唯一ID】字段，名称不一致或不存在时会导入失败',
  '必填字段若为空，将不会更新该字段': '必填字段若为空，将不会更新该字段',
  '有些特殊字段不会执行更新，包括有: 自增编码、引用字段、计算字段、附件，等每个对象下赋有特殊逻辑的字段': '有些特殊字段不会执行更新，包括有: 自增编码、引用字段、计算字段、附件，等每个对象下赋有特殊逻辑的字段',
  是否触发自动化流程: '是否触发自动化流程',
  是否触发审批流程: '是否触发审批流程',
  字段未填写时是否更新为空值: '字段未填写时是否更新为空值',
  保存为常用检索: '保存为常用检索',
  场景名称: '场景名称',
  数据范围: '数据范围',
  筛选条件: '筛选条件',
  请输入场景名称: '请输入场景名称'
};
